module.exports = __webpack_public_path__ + "img/Printing.f232265b.png";